import React from "react";

const StatusConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  userName,
  userStatus,
  statusMessage,
}) => {
  if (!isOpen) return null;

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "#28a745";
      case "inactive":
        return "#6c757d";
      case "pending":
        return "#ffc107";
      case "suspended":
        return "#dc3545";
      default:
        return "#6c757d";
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "active":
        return "✅";
      case "inactive":
        return "⏸️";
      case "pending":
        return "⏳";
      case "suspended":
        return "🚫";
      default:
        return "❓";
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <div
        className="status-confirmation-modal"
        style={{
          backgroundColor: "white",
          borderRadius: "15px",
          padding: "30px",
          maxWidth: "450px",
          width: "90%",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
          border: "1px solid #e0e0e0",
          position: "relative",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
            paddingBottom: "15px",
            borderBottom: "2px solid #f0f0f0",
          }}
        >
          <div
            style={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              backgroundColor: `${getStatusColor(userStatus)}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginRight: "15px",
              border: `3px solid ${getStatusColor(userStatus)}30`,
            }}
          >
            <span style={{ fontSize: "24px" }}>
              {getStatusIcon(userStatus)}
            </span>
          </div>
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: "20px",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              User Status Warning
            </h3>
            <p
              style={{
                margin: "5px 0 0",
                fontSize: "14px",
                color: "#666",
              }}
            >
              Please review before proceeding
            </p>
          </div>
        </div>

        {/* User Info */}
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "20px",
            borderRadius: "10px",
            marginBottom: "20px",
            border: "1px solid #e9ecef",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <strong style={{ color: "#333", fontSize: "16px" }}>
              Selected User:
            </strong>
            <span
              style={{
                marginLeft: "10px",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              {userName}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <strong style={{ color: "#333" }}>Current Status:</strong>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                padding: "5px 10px",
                borderRadius: "15px",
                backgroundColor: `${getStatusColor(userStatus)}15`,
                border: `1px solid ${getStatusColor(userStatus)}30`,
              }}
            >
              <span>{getStatusIcon(userStatus)}</span>
              <span
                style={{
                  color: getStatusColor(userStatus),
                  fontWeight: "600",
                  fontSize: "14px",
                  textTransform: "capitalize",
                }}
              >
                {statusMessage}
              </span>
            </div>
          </div>
        </div>

        {/* Warning Message */}
        <div
          style={{
            backgroundColor: "#fff3cd",
            border: "1px solid #ffeaa7",
            borderRadius: "8px",
            padding: "15px",
            marginBottom: "25px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
            }}
          >
            <span style={{ fontSize: "20px", marginTop: "2px" }}>⚠️</span>
            <div>
              <h4
                style={{
                  margin: "0 0 8px 0",
                  color: "#856404",
                  fontSize: "16px",
                }}
              >
                Delivery Warning
              </h4>
              <p
                style={{
                  margin: 0,
                  color: "#856404",
                  fontSize: "14px",
                  lineHeight: "1.4",
                }}
              >
                Creating items for non-active users may not deliver properly.
                The user's current status may prevent successful delivery
                processing.
              </p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "12px 24px",
              fontSize: "14px",
              fontWeight: "500",
              border: "2px solid #6c757d",
              borderRadius: "8px",
              backgroundColor: "white",
              color: "#6c757d",
              cursor: "pointer",
              transition: "all 0.2s ease",
              minWidth: "100px",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#6c757d";
              e.target.style.color = "white";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "white";
              e.target.style.color = "#6c757d";
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "12px 24px",
              fontSize: "14px",
              fontWeight: "500",
              border: "2px solid #ffc107",
              borderRadius: "8px",
              backgroundColor: "#ffc107",
              color: "#212529",
              cursor: "pointer",
              transition: "all 0.2s ease",
              minWidth: "120px",
            }}
            onMouseOver={(e) => {
              e.target.style.backgroundColor = "#e0a800";
              e.target.style.borderColor = "#e0a800";
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = "#ffc107";
              e.target.style.borderColor = "#ffc107";
            }}
          >
            Proceed Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusConfirmationModal;
